<template>
    <!-- <div class="outlet-banner" :style="{ 'background-image': 'url(/images/SHOP-BY-ROOM.jpg)' }">
        <div class="bg-section">
            <div class="bg-text">Returns and Refunds</div>
        </div>
    </div> -->
    <div class="base-container h-60vh">
        <div class="bg-section mb-5">
            <h1 class="bg-text text-center">Returns and Refunds</h1>
        </div>
        <div class="rules d-flex justify-content-center">
            <!-- 1. <strong> Cancellation of order: </strong>  -->
            <!-- Orders once placed will not be exchanged or cancelled. -->
            Order cancellation is not acceptable but product can be changed within three days. 
            It is not applicable for customized, set broken & fabrics products.


        </div>

        <!-- <div class="rules">
            2.<strong> Damaged Product reporting: </strong>
            <ol>
                <li>
                    We recommend that the buyer be present during delivery and
                    installation.
                </li>
                <li>
                    If the order/s arrives in a damaged condition, bring it to
                    the notice of the Delivery & Installation team immediately.
                    The team will assess the damage, and depending on the extent
                    of damage, will attempt to repair and install to your
                    satisfaction.
                </li>
                <li>
                    If the damaged order cannot be repaired on-the-spot, a
                    decision will be arrived at by our team at Akhtar Furnisher
                    within 7 to 10 working days. The product/s will be then
                    either repaired or replaced.
                </li>
                <li>
                    In case a manufacturing defect is detected later to
                    installation, report with the support of clear photographs,
                    written description in details, and the order number to
                    Customer Care at 16770 Or mail us at info@furniturewalla.com
                    FW will verify authenticity of the defect (buyer’s
                    compliance to adhere to the process of verification is
                    binding) and if found genuine, will attempt resolution.
                </li>
            </ol>
        </div>

        <div class="rules">
            3. <strong> Warranty</strong>
            <ol>
                <li>
                    All products are covered under one year warranty for
                    manufacturing defects (except polyurethane, PVC, Leather
                    Fabric parts or any Upholstery material).
                </li>
                <li>
                    If it is found that any physical damage to a product has
                    been caused due to negligence or mishandling by the
                    customer, Akhtar Furnisher will not be obliged to initiate a
                    replacement, refund or a credit note even if it is within
                    the 1 year warranty period.
                </li>
                <li>
                    Products within warranty period will be serviced free of
                    charge. Product out of warranty period will attract
                    appropriate charges.
                </li>
            </ol>
        </div>

        <div class="rules">
            4. <strong> Damaged Product resolution: </strong> If accepted, Akhtar
            will attempt resolution for product with manufacturing damage in one
            of the following ways, at company’s discretion. The Warranty
            conditions will apply for charges and the mode of resolution
            <ol>
                <li>Repair at buyer’s location.</li>
                <li>Repair at Service Centre.</li>
                <li>
                    Replacement with a product of buyer’s choice of same price.
                    Any price difference will either be paid for by the buyer or
                    paid back by Akhtar Furnisher to the buyer with a credit
                    note/refund.
                </li>
            </ol>
        </div>

        <div class="rules">
            5. <strong> Modification of product: </strong> Akhtar strictly
            recommends against the modification of any of its products whether
            in part or whole.
        </div> -->

        <!-- <div class="rules">
            6. <strong>Exchange</strong>
            <ol>
                <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Tenetur necessitatibus totam quas dicta laboriosam hic odit,
                    voluptatibus eum distinctio possimus aspernatur nulla
                    blanditiis aliquam incidunt amet nostrum reprehenderit minus
                    debitis. Laborum reprehenderit repellat provident corrupti
                    esse vero consequuntur quam suscipit tenetur mollitia
                    perspiciatis quas ipsum velit, ab sunt voluptatum iure. Cum
                    quos minima quis sapiente atque hic optio voluptate omnis?
                </li>
                <li>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Dolorem eligendi reprehenderit vitae tenetur repellendus,
                    quae illo repellat placeat enim voluptates blanditiis id
                    rerum. Placeat quam temporibus nesciunt optio doloremque in.
                </li>
            </ol>
        </div> -->
    </div>
</template>

<script></script>

<style lang="scss">
.base-container {
    padding: 100px 10%;
}

.hr-line {
    border: 1px solid #e6e6e6;
    margin-bottom: 30px;
}

.return-and-refund-headline {
    font-weight: 500;
    font-size: 30px;
}

.rules {
    font-weight: 400;
    font-size: 20px;
    line-height: 130%;

    margin-bottom: 20px;
}

.outlet-banner {
    background-color: #f5f5f5;
    padding: 0 10%;
    height: 30vh;
    text-align: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

@media screen and (min-width: 577px) and (max-width: 1024px) {
    .base-container {
        padding: 90px !important;
    }

    .hr-line {
        border: 1px solid #e6e6e6;
        margin-bottom: 30px;
    }

    .return-and-refund-headline {
        font-weight: 500;
        font-size: 25px;
    }

    .rules {
        font-weight: 400;
        font-size: 18px;
        line-height: 130%;

        margin-bottom: 20px;
    }
}

@media screen and (min-width: 0px) and (max-width: 576px) {
    .base-container {
        padding: 60px;
    }

    .hr-line {
        border: 1px solid #e6e6e6;
        margin-bottom: 30px;
    }

    .return-and-refund-headline {
        font-weight: 500;
        font-size: 20px;
    }

    .rules {
        font-weight: 400;
        font-size: 15px;
        line-height: 130%;

        margin-bottom: 20px;
    }
}
</style>
